// features/webSocketSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IReceivedMessage } from '../../../interface/interfaces';

interface WebSocketState {
    sendMassage: string;
    receivedMessage: IReceivedMessage;
}

const initialState: WebSocketState = {
    sendMassage: '',
    receivedMessage: {
        messageType: 'success',
        text: '',
        isLoading: false,
    },
};

const webSocketSlice = createSlice({
    name: 'webSocket',
    initialState,
    reducers: {
        sendMessage(state, action: PayloadAction<string>) {
            // Ovde možemo dodati logiku za dodavanje poslatih poruka u stanje, ali to nećemo raditi ovde
            // state.messages.push(`You: ${action.payload}`);
            state.sendMassage = action.payload;
        },
        receiveMessage(state, action: PayloadAction<IReceivedMessage>) {
            // Dodajemo primljenu poruku u niz poruka
            // state.messages.push(`Server: ${action.payload}`);
            state.receivedMessage = action.payload;
        },

        clearMessages(state) {
            (state.receivedMessage = initialState.receivedMessage), (state.sendMassage = initialState.sendMassage);
        },
    },
});

export const { sendMessage, receiveMessage, clearMessages } = webSocketSlice.actions;

export default webSocketSlice.reducer;
